import Api from './Api'
import _ from 'lodash'

export default {
  view (objektId) {
    return Api().get('/objekt/' + objektId + '.json')
  },
  sendObjektToElastic (objektnr) {
    return Api().post('/objekt/update-elastic.json', { Objektnr: objektnr })
  },
  update (objektId, data) {
    return Api().put('/objekt/' + objektId + '.json', data)
  },
  getLastOppgjorLog (objektId) {
    return Api().get('/logg/find-last-oppgjor-by-objekt/' + objektId + '.json')
  },
  getObjektBilag (objektId, bilagId) {
    return Api().get('/objekt/' + objektId + '/bilag/' + bilagId + '.json')
  },

  duplicate (objektId, count = 1) {
    return Api().post('/objekt/' + objektId + '/duplicate.json', { count: count || 1 })
  },

  getObjektNotater (objektId, queryParams) {
    return Api().get('/objekt/' + objektId + '/objektnotat.json', {
      params: queryParams
    })
  },

  addObjektNotat (objektId, data) {
    return Api().post('/objekt/' + objektId + '/objektnotat.json', data)
  },

  delObjektNotat (objektId, notatId) {
    return Api().delete('/objekt/' + objektId + '/objektnotat/' + notatId + '.json')
  },

  sendObjektNotatToAccounting (objektId, notatId) {
    return Api().get('/objekt/' + objektId + '/objektnotat/' + notatId + '/send-to-accounting.json')
  },

  getObjektPhotos (objektId) {
    return Api().get('objekt/' + objektId + '/photo.json')
  },

  getObjektBesikt (objektId) {
    return Api().get('objekt/' + objektId + '/besikt.json')
  },
  saveObjektBesikt (objektId, data) {
    return Api().post('objekt/' + objektId + '/besikt.json', data)
  },

  getObjektKonsult (objektId) {
    return Api().get('objekt/' + objektId + '/konsult.json')
  },

  saveObjektKonsult (objektId, data) {
    return Api().post('objekt/' + objektId + '/konsult.json', data)
  },

  getNotReady (queryParams) {
    return Api().get('/objekt/notready.json', {
      params: queryParams
    })
  },

  printLabels (objektId, data) {
    return Api().post('objekt/' + objektId + '/print-labels.json', data)
  },

  reloadPhotos (objektId) {
    return Api().get('objekt/' + objektId + '/photo-reload.json')
  },
  getPhotoUrls (objektNr, size) {
    return Api().get('/objekt/photo_urls_fotoware.json', {
      params: { objektnr: objektNr, size: size }
    })
  },

  getObjektBilagOptions (objektId) {
    return Api().get('/objekt/' + objektId + '/bilag/options.json')
  },

  getSellerObjektWithDraftBilag (objektList) {
    // Hämta oppjgor-drafts för selger, utan tillslag & salar
    return Api().post('/objekt/bilag_draft_seller.json', objektList)
  },
  getObjektBilagList (objektList) {
    // Hämta oppjgor-drafts för selger, utan tillslag & salar
    return Api().post('/objekt/bilag_list.json', objektList)
  },
  getObjektBilagBuyer (objektId) {
    return Api().get('/objekt/' + objektId + '/bilag/buyer.json')
  },
  getObjektBilagBuyerAr (objektId) {
    return Api().get('/objekt/' + objektId + '/bilag/buyer.json', {
      params: { ar: true }
    })
  },

  saveObjektBilagBuyer (objektId, data) {
    return Api().post('/objekt/' + objektId + '/bilag/buyer.json', data)
  },
  saveEoFaktura (data) {
    return Api().post('/bilag/eofaktura.json', data)
  },
  saveKreditNota (data) {
    return Api().post('/bilag/kreditnota.json', data)
  },
  saveKreditNotaWithout24 (data) {
    return Api().post('/bilag/kreditnotaWithout24.json', data)
  },
  getObjektBilagSeller (objektId) {
    return Api().get('/objekt/' + objektId + '/bilag/seller.json')
  },
  setMottakerObjekt (objektId, mottakerId) {
    return Api().post('/objekt/' + objektId + '/bilag/mottaker/' + mottakerId + '.json')
  },
  saveObjektBilagSeller (objektId, data) {
    return Api().post('/objekt/' + objektId + '/bilag/seller.json', data)
  },
  saveToTwentyfour (objektId) {
    return Api().post('/objekt/' + objektId + '/export/settlement.json')
  },
  deleteBilagsLine (objektId, bilagslinjeId) {
    return Api().delete('/objekt/' + objektId + '/bilag/line/' + bilagslinjeId + '.json')
  },
  creditSetlement (objektId) {
    return Api().post('/objekt/' + objektId + '/credit/settlement.json')
  },
  creditSetlementWithout24 (objektId) {
    return Api().post('/objekt/' + objektId + '/credit/settlementWithout24.json')
  },
  createBesiktPdf (objektId, postData) {
    return Api().post('/objekt/' + objektId + '/besikt/pdf.json', postData)
  },
  startLagerleie: function (objektId) {
    return Api().post('/objekt/' + objektId + '/start-lagerleie.json')
  },

  getBesiktPdf: function (objektId, postData) {
    return Api().post('/objekt/' + objektId + '/besikt/get-historical-pdf.json', postData)
  },

  getKundeKontraktPdf (kundeId, kontraktId, postData) {
    return Api().post('/kunde/' + kundeId + '/kontrakt/' + kontraktId + '/get-historical-pdf.json', postData)
  },

  stopLagerleie: function (objektId) {
    return Api().post('/objekt/' + objektId + '/stop-lagerleie.json')
  },
  resetLagerleie: function (objektId) {
    return Api().post('/objekt/' + objektId + '/reset-lagerleie.json')
  },
  getManuslist (postData) {
    return Api().post('/objekt/manuslist.json', postData)
  },

  getBesiktWithLog (queryParams) {
    return Api().get('/objekt/besikt-with-log.json', {
      params: queryParams
    })
  },

  getPoliceReport (data) {
    return Api().post('/objekt/policereport.json', data)
  },

  getWineReport (data, queryParams) {
    return Api().post('/objekt/winereport.json', data, {
      params: queryParams
    })
  },

  getKjoperrapport (data) {
    return Api().post('/objekt/kjoperrapport.json', data)
  },

  getTilslagsList (postData, queryParams) {
    return Api().post('/objekt/tilslagslist.json', postData, {
      params: queryParams
    })
  },

  getTilslagsTotals (postData, queryParams) {
    return Api().post('/objekt/tilslagstotals.json', postData, {
      params: queryParams
    })
  },

  updateTilslag (objektId, postData) {
    return Api().post('/objekt/' + objektId + '/update-tilslag.json', postData)
  },

  getForhandsbudList (postData, queryParams) {
    return Api().post('/objekt/forhandsbudlist.json', postData, {
      params: queryParams
    })
  },

  getTelefonbudList (postData, queryParams) {
    return Api().post('/objekt/telefonbudlist.json', postData, {
      params: queryParams
    })
  },

  getUtleveringsseddelPdf: function (objektId, postData) {
    return Api().post('/objekt/' + objektId + '/utleveringsseddel/get-historical-pdf.json', postData)
  },

  loadFormDropdowns () {
    var self = this

    return new Promise((resolve, reject) => {
      Api().get('objekt/dropdowns.json')
        .then((response) => {
          let payload = {
            avdeling: response.data.avdeling,
            expertavdeling: response.data.expertavdeling,
            kategori: response.data.kategori,
            label: {
              tree: response.data.label,
              flat: []
            },
            objekttype: response.data.objekttype,
            lokasjon: response.data.lokasjon,
            objektsignert: response.data.objektsignert,
            merknad: response.data.merknad,
            fraktgruppe: response.data.fraktgruppe,
            tag: response.data.tag
          }

          self.flattenTree(response.data.label, [], function (flattened) {
            payload.label.flat = flattened
          })

          resolve(payload)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  },

  flattenTree: function (inArray, toArray, callback) {
    if (typeof inArray === 'object' && inArray.length > 0) {
      inArray.forEach((item) => {
        if (item.children && item.children.length > 0) {
          this.flattenTree(item.children, toArray)
        }

        toArray.push(_.omit(item, 'children'))
      })
    }

    if (callback) {
      callback(toArray)
    }
  },

  getObjectStoraged: function (params) {
    return Api().get('/objekt/getobjectsforstoragefeecron.json', {
      params: params
    })
  },

  getBidHistoryComplete (objectId) {
    return Api().get('/objekt/bidhistorycomplete/' + objectId + '.json')
  }
}



// WEBPACK FOOTER //
// ./src/services/ObjektService.js